import { useCircularLog } from './useCircularLog';

var globalLog = null; //return { addToLog, clearLog, logs };

export function useGlobalCircularLog(maxRows) {
    if (null == globalLog) {
      globalLog = useCircularLog (maxRows);
    }
    return globalLog;
}